import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting.js';
import { fetchUserDataById } from '../../services2/users.service.js';
import CATEGORIESSVG from '../../svg/teacher/Categories.js'
import { studentFetchStudentAnswers } from '../../services2/studentAnswers.service.js';
import { studentFetchMissions } from '../../services2/missions.service.js';

const LAST_MISSION = {
  name: '天下襟懷',
  subtitle: '〈岳陽樓記〉｜〈醉翁亭記〉',
  progress: 0,
  CATEGORIES: ['文化傳統', '作者處境'],
  image: '/secondary/tasks/1_.png'
}

const RESEARCHES = [
  // {
  //   id: '100',
  //   name: 'Pilot Test',
  //   image: '/secondary/tasks/11.png',
  //   subtitle: '研究測試 Pilot Test',
  //   link: '/platform2/research-practices/preview/100'
  // },
    {        
    id: '1001',
    name: '前測',
    image: '/secondary/tasks/11.png',
    subtitle: '研究測試-前測',
    link: '/platform2/research-practices/preview/1001',
  }

]
const CATEGORIES = [
  { id: '歷史背景' },
  { id: '文化傳統' },
  { id: '文學賞讀' },
  { id: '作者處境' },
  { id: '讀者回應' },
  { id: "文本特色" }
]
function Component(props) {
  const navigate = useNavigate();
  const { fontSize } = useSetting();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)

  const [user, setuser] = useState(null)
  async function fetchData() {
    let result = await fetchUserDataById(props.token.token)
    if (result.result) {
      setuser(result.result)

    }
  }
  useEffect(() => {
    fetchData();
  }, [])

  const [selectedCategory, setselectedCategory] = useState(null)
  const handleToggleCategory = (categoryId) => {
    if (categoryId === selectedCategory) {
      setselectedCategory(null);
    } else {
      setselectedCategory(categoryId);
    }
  };

  const [lastMission, setLastMission] = useState(null)
  async function fetchLastAnswer() {
    let result = await studentFetchStudentAnswers(props.token.token, {}, { limit: 1, skip: 0, sort: { createDate: -1 } });
    if (result.result && result.result.length > 0) {
      let lastMissionId = result.result[0].missionId;
      let lastMissionResult = await studentFetchMissions(props.token.token,{_id:lastMissionId});
      if (lastMissionResult.result?.[0]) {
        setLastMission(lastMissionResult.result[0]);
      }
    }
  }
  useEffect(() => {
    fetchLastAnswer();
  }, []);



  return (
    <div className='h-full flex-1 bg-[#EDF5F8] p-[12px] flex flex-col gap-[16px] overflow-auto' style={{ fontSize, backgroundImage: 'url(/secondary/bg.png)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>

      <div style={{ color: '#4B555C', fontSize: fontSize, fontWeight: '900' }}>歡迎回來, {user ? user.name : ''} [{user ? user.username : ''}]</div>
      <div className='relative flex flex-col items-start'>
        <img src='/secondary/title.png' alt='' style={{ height: '102px', objectFit: 'contain' }} />
      </div>
      <div className='w-full flex flex-row gap-[4px] flex-wrap'>
        <div className='flex flex-col gap-[16px] justify-center relative pt-[42px]'>

          <div className='text-[#003A57] font-bold'>歷史、文化、文學</div>
          <div className='flex flex-row gap-[8px]'>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[0].id) ? { background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[0].id)}>
              {CATEGORIES[0].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[1].id) ? { background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[1].id)}>
              {CATEGORIES[1].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[2].id) ? { background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[2].id)}>
              {CATEGORIES[2].id}
            </button>
          </div>
          <div className='text-[#003A57] font-bold'>作者、讀者、文本</div>
          <div className='flex flex-row gap-[8px]'>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[3].id) ? { background: 'white', color: '#108B96', boxShadow: '0 2px 10px #0050C890' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[3].id)}>
              {CATEGORIES[3].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[4].id) ? { background: 'white', color: '#108B96', boxShadow: '0 2px 10px #0050C890' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[4].id)}>
              {CATEGORIES[4].id}
            </button>
            <button
              className='px-[16px] rounded-full py-[4px] font-bold'
              style={(!selectedCategory) || (selectedCategory === CATEGORIES[5].id) ? { background: 'white', color: '#108B96', boxShadow: '0 2px 10px #0050C890' } : { color: '#6B6E70', background: 'linear-gradient(to right, #BEBEBE90, #fff)' }}
              onClick={() => handleToggleCategory(CATEGORIES[5].id)}>
              {CATEGORIES[5].id}
            </button>
          </div>
          <div className=''>
            {selectedCategory ? <button className='flex flex-row items-center gap-[4px] text-[#A9FFDC] px-[16px]  py-[4px] rounded-full bg-[#009191] font-bold h-[38px]' onClick={() => { setselectedCategory(null) }}>
              <img src='/secondary/reset.png' alt='' style={{ height: '16px', objectFit: 'contain' }} />
              重設
            </button> :
              <div className='h-[38px]'></div>}
          </div>
        </div>

        <CATEGORIESSVG handleToggleCategory={handleToggleCategory} selectedCategory={selectedCategory} />
        <div className='flex flex-col flex-1'>
          <div className='flex flex-col justify-center max-h-[500px]'>
            <div className='text-[#003A57] font-bold min-h-[100px] p-[16px] w-[100%] max-w-[800px] min-w-[200px] max-h-[100%] h-full overflow-auto ' style={{ border: '2px solid white', borderRadius: '8px' }}>
              <b style={{ fontSize: fontSize + 6 }}>課程目標</b>
              <p className='text-black font-[600]'>
                <br />
                本計劃透過網上學習平台的多文本閱讀，鼓勵學生開展探究式學習，培養在多模態情境中的深度閱讀能力與數字素養。學生圍繞著「核心問題」，對不同文本進行比較、整合、查證與評價，促進深度閱讀與靈活應用。
                <br /><br />

                {selectedCategory === CATEGORIES[0].id && <div className='flex flex-row'><div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' }}>{CATEGORIES[0].id}</div></div>}
                {selectedCategory === CATEGORIES[0].id && <p className='mt-[16px]'>將作品置放於具體的歷史場景之中，梳理其中錯綜複雜的關係，拓展思考的廣度。</p>}
                {selectedCategory === CATEGORIES[1].id && <div className='flex flex-row'><div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' }}>{CATEGORIES[1].id}</div></div>}
                {selectedCategory === CATEGORIES[1].id && <p className='mt-[16px]'>認識中華文化的精義，梳理其發展脈絡，思考自身在文化傳承中的角色。</p>}
                {selectedCategory === CATEGORIES[2].id && <div className='flex flex-row'><div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' }}>{CATEGORIES[2].id}</div></div>}
                {selectedCategory === CATEGORIES[2].id && <p className='mt-[16px]'>研讀相關作品，積累對作品的分析、鑑賞與評價能力，從而涵養中文閱讀素養。</p>}
                {selectedCategory === CATEGORIES[3].id && <div className='flex flex-row'><div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'white', color: '#108B96', boxShadow: '0 2px 10px #0050C890' }}>{CATEGORIES[3].id}</div></div>}
                {selectedCategory === CATEGORIES[3].id && <p className='mt-[16px]'>探索作者在特定社會、文化或歷史時空中的思考、掙扎或選擇，把作者還原為有血有肉的人。</p>}
                {selectedCategory === CATEGORIES[4].id && <div className='flex flex-row'><div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'white', color: '#108B96', boxShadow: '0 2px 10px #0050C890' }}>{CATEGORIES[4].id}</div></div>}
                {selectedCategory === CATEGORIES[4].id && <p className='mt-[16px]'>閱讀並非單向接收或操練，而是讀者帶著自身經驗與認知，跟文本進行深度對話。</p>}
                {selectedCategory === CATEGORIES[5].id && <div className='flex flex-row'><div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'white', color: '#108B96', boxShadow: '0 2px 10px #0050C890' }}>{CATEGORIES[5].id}</div></div>}
                {selectedCategory === CATEGORIES[5].id && <p className='mt-[16px]'>從文本的獨特之處（例如詩的意象）切入，深入挖掘文本的藝術韻味與深層意義。</p>}

                {/* 歷史背景：將作品置放於具體的歷史場景之中，梳理其中錯綜複雜的關係，拓展思考的廣度。
              <br /><br />
              文化傳統：認識中華文化的精義，梳理其發展脈絡，思考自身在文化傳承中的角色。
              <br /><br />
              文學賞讀：研讀相關作品，積累對作品的分析、鑑賞與評價能力，從而涵養中文閱讀素養。
              <br /><br />
              作者處境：探索作者在特定社會、文化或歷史時空中的思考、掙扎或選擇，把作者還原為有血有肉的人。
              <br /><br />
              讀者回應：閱讀並非單向接收或操練，而是讀者帶著自身經驗與認知，跟文本進行深度對話。
              <br /><br />
              文本特色：從文本的獨特之處（例如詩的意象）切入，深入挖掘文本的藝術韻味與深層意義。 */}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='w-full flex flex-row gap-[6px] flex-wrap text-[#003A57]' >
        {/*last mission*/}
        <div className='relative flex-1 flex flex-col p-[8px] rounded-[16px] min-w-[400px] font-bold overflow-hidden' style={{ aspectRatio: '763/403', backgroundImage: `url(${lastMission?lastMission?.photo:LAST_MISSION.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className='absolute bottom-0 left-0 right-0 h-[50%] z-[1]' style={{ background: 'linear-gradient(to top, rgba(255,255,255,1), rgba(0,0,0,0))' }} />

          <div className='flex flex-row items-center justify-start gap-[16px] z-[2] font-[900]' style={{}}>
            互文閱讀
            {lastMission && <div className='bg-[#EE8D59] text-white px-[8px] py-[4px] flex flex-col rounded-full font-bold noto-san-hk' style={{ fontSize: fontSize - 4 }}>上次單元</div>}
          </div>
          <div className='flex flex-col justify-end flex-1 z-[2]'>
            <div className='flex flex-row items-center justify-start gap-[16px] '>
              <div style={{ fontWeight: 'bold', fontSize: fontSize + 4 }}>{lastMission ? lastMission.name : LAST_MISSION.name}</div>
              <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' }}>
                {lastMission? lastMission?.pages?.[0]?.category : CATEGORIES[1].id}
              </div>
              <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'white', color: '#108B96' }}>
                {lastMission? lastMission?.pages?.[1]?.category : CATEGORIES[3].id}
              </div>
            </div>
            <div className='text-black mt-[8px]' style={{ fontWeight: 'bold' }}>{lastMission? `〈${lastMission.pages?.[0]?.name}〉${lastMission.pages?.[1]?.name&&'|'} ${lastMission.pages?.[1]?.name?`〈${lastMission.pages?.[1]?.name}〉`:''}`:LAST_MISSION.subtitle}</div>
            <div className='flex flex-row w-full items-center text-[#005B8C] gap-[16px]'>
              進度
              <div className='w-[50%] relative rounded-full h-[8px] bg-gray-200 overflow-hidden'>
                <div className='absolute top-0 left-0 h-[8px] bg-[#178E95]' style={{ width: `${lastMission?0:LAST_MISSION.progress * 100}%` }} />
              </div>
              {`${lastMission?0:Math.round(LAST_MISSION.progress * 100)}%`}
              <div className='flex-1 flex flex-row justify-end'>
                <button className='text-[#007A83] font-bold mb-[6px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                  <div className='rounded-full px-[12px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}
                    onClick={() => { navigate(lastMission? `/platform2/missions?id=${lastMission._id}` : '/platform2/missions?id=697dc4b5e8bafeb9a0867f07') }}
                  >
                    {lastMission ? '繼續單元' : '開始單元'}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='flex-1 flex flex-col p-[8px] rounded-[16px] min-w-[400px] font-bold ' style={{ border: '2px solid white' }}>
          <div className='flex flex-row items-center justify-between'>
            研究測試
            <button className='text-[#007A83] font-bold noto-san-hk' style={{ fontSize: fontSize - 2 }} onClick={() => navigate('/platform2/research-practices')}>
              {' 全部研究測試  >'}
            </button>
          </div>
          <div className='w-full flex flex-row overflow-x-auto gap-[16px] justify-start items-stretch mt-[16px] flex-1'>
            {RESEARCHES.map((item) =>
              <div key={item} className='flex-1 min-w-[150px] max-w-[280px] bg-[#ffffff80] rounded-[8px] flex flex-col overflow-hidden h-full' style={{ border: '2px solid white' }}>
                <img src={item.image} alt={item.name} className='w-full object-cover' />
                <div className='px-[8px] font-bold my-[4px]'>{item.name}</div>
                <div className='px-[8px] text-[black] noto-san-hk' style={{ fontSize: fontSize - 4 }}>{item.subtitle}</div>
                <div className='flex-1 flex flex-col items-end justify-end'>
                  <button onClick={() => navigate(item.link)} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                    <div className='rounded-full px-[12px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                      {'開始測試'}
                    </div>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>


      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
